import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { RUNTIME_CONFIG } from '@environments/runtime-config.token';
import { Observable } from 'rxjs';
import {
  NotificationEvent,
  NotificationEventSetting,
  NotificationPreview,
  NotificationPreviewQuery,
  NotificationSettingLine,
  NotificationSettingLinePayload,
} from './notification-setting.model';

export interface INotificationSettingService {
  list(): Observable<NotificationEventSetting[]>;
  get(event: NotificationEvent): Observable<NotificationEventSetting>;
  preview(
    event: NotificationEvent,
    query: NotificationPreviewQuery,
  ): Observable<NotificationPreview>;
  createLine(
    event: NotificationEvent,
    payload: NotificationSettingLinePayload,
  ): Observable<NotificationSettingLine>;
  updateLine(
    lineId: string,
    payload: NotificationSettingLinePayload,
  ): Observable<NotificationSettingLine>;
  deleteLine(lineId: string): Observable<void>;
}

/**
 * Le réglage des notifications : consultable par tout utilisateur interne, modifiable par le
 * directeur général, le directeur RH et le gestionnaire des processus (RG-notification-droit-de-regler).
 */
@Injectable({ providedIn: 'root' })
export class NotificationSettingService implements INotificationSettingService {
  private http = inject(HttpClient);
  private url = `${inject(RUNTIME_CONFIG).apiUrl}/notification-settings`;

  list(): Observable<NotificationEventSetting[]> {
    return this.http.get<NotificationEventSetting[]>(this.url);
  }

  get(event: NotificationEvent): Observable<NotificationEventSetting> {
    return this.http.get<NotificationEventSetting>(`${this.url}/${event}`);
  }

  preview(
    event: NotificationEvent,
    query: NotificationPreviewQuery,
  ): Observable<NotificationPreview> {
    return this.http.post<NotificationPreview>(`${this.url}/${event}/preview`, query);
  }

  createLine(
    event: NotificationEvent,
    payload: NotificationSettingLinePayload,
  ): Observable<NotificationSettingLine> {
    return this.http.post<NotificationSettingLine>(`${this.url}/${event}/lines`, payload);
  }

  updateLine(
    lineId: string,
    payload: NotificationSettingLinePayload,
  ): Observable<NotificationSettingLine> {
    return this.http.put<NotificationSettingLine>(`${this.url}/lines/${lineId}`, payload);
  }

  deleteLine(lineId: string): Observable<void> {
    return this.http.delete<void>(`${this.url}/lines/${lineId}`);
  }
}
